// click2callSettings.js
import ApiClient from './ApiClient';

export default new class extends ApiClient {
  constructor() {
    // Will result in `/api/v1/accounts/:account_id/click2call`
    super('click2call', { accountScoped: true });
  }

  // get saved click2call settings
  async getSettings() {
    return await axios.post(`${this.url}/click2call_request`, undefined, {
      params: { proc: 'get_settings' },
    });
  }
// set click2call settings

  async setSettings(data) {
    return await axios.post(`${this.url}/click2call_request`, data, {
      params: { proc: 'set_settings' },
    });

  }
  async deleteSettings() {
    try{
      return await axios.post(`${this.url}/click2call_request`, undefined, {
        params: { proc: 'delete_settings' },
      });
    } catch (error){
      console.error("error",error);
    }
    return null;
  }

  async enableClick2Call() {
    // 1. Fetch existing settings
    const response = await this.getSettings();
    const currentSettings = response.data || {};
  
    // 2. Safely update only the 'enable' field
    const updatedSettings = {
      ...currentSettings,
      enable: true,
    };
  
    // 3. Save the full settings object back
    return await this.setSettings(updatedSettings);
  }
  async triggerClick2Call({ url, method = 'POST', payload = {}, headers = {} }) {
    try {
      const response = await axios.post(`${this.url}/trigger`, {
        url,
        method,
        payload,
        headers,
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  

  // Optional stub methods to match pattern
  get() { throw 'not implemented'; }
  show() { throw 'not implemented'; }
  create() { throw 'not implemented'; }
  update() { throw 'not implemented'; }
  delete() { throw 'not implemented'; }
};
